import http from "../utils/http-common";

class CustomersDataService {
  getAll() {
    return http.get("/customers");
  }
  getAllForList() {
    return http.get("/customers?limit=100000&ascending=1&activeOnly=1");
  }

  get(id) {
    return http.get(`/customers/${id}`);
  }

  findByPib(pib) {  
    return http.get(`/customers/pib/${pib}`);
  }

  findByMb(mb) {
    return http.get(`/customers/mb/${mb}`);
  }

  create(data) {
    return http.post("/customers", data);
  }

  update(id, data) {
    return http.put(`/customers/${id}`, data);
  }

  delete(id) {
    return http.delete(`/customers/${id}`);
  }
}

export default new CustomersDataService();